var _circle, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 65,
    r: 38.4,
    fill: "none",
    stroke: "#F6AE06",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 75,
    textAnchor: "middle",
    fill: "#F6AE06",
    fontFamily: "Poppins, sans-serif",
    fontSize: 36,
    fontWeight: "bold"
  }, "!")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 135,
    textAnchor: "middle",
    fill: "#333",
    fontFamily: "Poppins, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "No Data Found")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAvailable);
export default __webpack_public_path__ + "static/media/noDataAvailable.686b130a41891377cedc3b90e565208a.svg";
export { ForwardRef as ReactComponent };